import { SVGProps, Ref, forwardRef } from 'react';

export const HhProGrayscaleSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M29.532 6.607c.132.46 1.077 3.651 1.377 6.99l.069.868c.151 1.82-.469 3.556-1.723 4.906-1.337 1.433-3.252 2.05-5.278 2.05H8.033c-2.012 0-3.941-.617-5.278-2.05-1.254-1.35-1.874-3.1-1.736-4.906l.069-.868c.317-3.528 1.323-6.904 1.364-7.042.124-.385.441-.675.84-.758.4-.082.8.056 1.062.373l.882 1.047C6.31 8.512 7.992 9.174 9.714 8.98c1.695-.193 3.156-1.185 3.9-2.66l1.378-2.715c.193-.386.579-.606.979-.606h.027c.4 0 .786.22.979.606l1.378 2.715c.744 1.475 2.204 2.467 3.9 2.66a5.1 5.1 0 0 0 4.478-1.764l.882-1.047a1.1 1.1 0 0 1 1.061-.373c.4.083.73.373.84.758z"
            fill="#919191"
        />
        <path d="M4.424 22.973a2.219 2.219 0 0 0 0 4.438h23.155a2.219 2.219 0 0 0 0-4.438z" fill="#919191" />
    </svg>
));
HhProGrayscaleSize32Glyph.displayName = 'HhProGrayscaleSize32Glyph';
